// src/components/HeroSection.jsx
import React from 'react';
import CalendlyButton from './CalendlyButton';
import heroImg from '../assets/images/hero/hero-image-10.png'; // adapte le chemin si nécessaire

const HeroSection = () => {
  return (
    <section className="relative bg-white pb-[110px] pt-[120px] lg:pt-[150px] dark:bg-dark">
      <div className="container mx-auto">
        <div className="-mx-4 flex flex-wrap items-center">
          {/* Texte gauche */}
          <div className="w-full px-4 lg:w-5/12">
            <div className="hero-content">
              <h1 className="mb-6 text-4xl font-extrabold leading-tight text-dark sm:text-[42px] lg:text-[40px] xl:text-5xl dark:text-white">
                Amplifiez votre <br />
                <span className="text-blue-600">Communication & Impact.</span>
              </h1>

              <p className="mb-4 max-w-[520px] text-lg text-gray-700 dark:text-gray-300">
                Boostez votre visibilité et votre influence sur LinkedIn grâce à notre plateforme IA et notre expertise stratégique.
              </p>

              <p className="mb-8 max-w-[520px] text-base text-gray-600 dark:text-gray-400">
                Près d’un milliard de membres actifs sur LinkedIn. <br />
                80 % des entreprises leaders s’appuient sur des benchmarks sectoriels pour affiner leurs stratégies de communication.
              </p>

              <div className="flex justify-center lg:justify-start mt-10 mb-10">
                <CalendlyButton
                  text="Démarrer maintenant"
                  className="inline-flex items-center justify-center rounded-md bg-blue-600 px-6 py-3 text-base font-medium text-white hover:bg-blue-800 transition"
                />
              </div>
            </div>
          </div>

          {/* Image droite */}
          <div className="w-full px-4 lg:w-6/12">
            <div className="lg:ml-auto lg:text-right">
              <img
                src={heroImg}
                alt="Illustration communication IA"
                className="max-w-full rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
